
import { useContext } from 'react';
import { BulkUpdatePermissionsContext } from 'components/bulk-update';

const useBulkUpdateWorkItemPermissions = () => useContext(BulkUpdatePermissionsContext);

export default useBulkUpdateWorkItemPermissions;